import cx from "classnames";
import React from "react";
import { FormErrors } from "redux-form";

import { Form } from "@/mk2/components/Form";
import { InputField } from "@/mk2/components/forms/InputField";
import { SubmitButton } from "@/mk2/components/forms/SubmitButton";
import { MKReduxFormInjectedProps, mkReduxForm } from "@/mk2/decorators/mkReduxForm";
import {
    ENTER_EMAIL_OR_USERNAME_YOU_HAVE_REGISTERED,
    PASSWORD_RESET_EMAIL_OR_USERNAME_INVALID,
    SEND,
    YOU_DID_NOT_ENTER_EMAIL,
} from "@/mk/autogenerated/translations/PasswordResetEmailForm.ad71be8b91f382daa08ee4277a958fe8";

import styles from "./PasswordResetEmailForm.mscss";

export const FORM_NAME = "PASSWORD_RESET_EMAIL_FORM";

export interface FormValues {
    usernameOrEmail: string;
}

interface OwnProps {
    className?: string;
    initialValues: FormValues;
    onSave(values: FormValues);
}

type Props = OwnProps;

class PasswordResetEmailForm extends React.Component<
    Props & MKReduxFormInjectedProps<FormValues, Props>
> {
    public render() {
        const { className, handleSubmit, form } = this.props;

        return (
            <Form className={cx(styles.PasswordResetEmailForm, className)} onSubmit={handleSubmit}>
                <InputField
                    name="usernameOrEmail"
                    type="text"
                    label={ENTER_EMAIL_OR_USERNAME_YOU_HAVE_REGISTERED}
                    autoCapitalize="off"
                    autoCorrect="off"
                    autoFocus
                    marginLeft={false}
                />
                <SubmitButton
                    className={styles.PasswordResetEmailForm__submit}
                    label={SEND}
                    formName={form}
                />
            </Form>
        );
    }
}

function validate(values: FormValues): FormErrors<FormValues> {
    const errors: FormErrors<FormValues> = {};
    if (!values.usernameOrEmail.trim()) {
        errors.usernameOrEmail = YOU_DID_NOT_ENTER_EMAIL;
    } else if (
        !/^[a-zA-Z\d.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?(?:\.[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?)*$/.test(
            values.usernameOrEmail.trim(),
        ) &&
        !/^[a-zA-Z\d.][a-zA-Z\d.\-_]+$/.test(values.usernameOrEmail.trim())
    ) {
        errors.usernameOrEmail = PASSWORD_RESET_EMAIL_OR_USERNAME_INVALID;
    }

    return errors;
}

export default mkReduxForm<FormValues, Props>({
    formName: FORM_NAME,
    onValidate: validate,
    onSave: (values, props) => props.onSave(values),
})(PasswordResetEmailForm);
